import React, { useLayoutEffect, useRef, useState, useEffect } from "react";
import { useCookies } from 'react-cookie';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import "./LineChart.css";

const LineChart = ({ task, onLastValueChange, mode}) => {
  const chartRef = useRef(null);
  const seriesRef = useRef(null);
  const scrollbarXRef = useRef(null);
  const zoomedOnceRef = useRef(false);

  const [datos, setData] = useState(null);
  const [cookies] = useCookies(['session_id', 'user']);
  const id = new URLSearchParams(window.location.search).get('id');

  let lastId = 0, lastUnix = 0;
  let tiempo = mode === 'resumen' ? 60000 : 5000;   // 1 minute vs 5 seconds (resume vs real time chart)
  let top = mode === 'resumen' ? 1200 : 600;        // data size (resume vs real time chart)

  let DS = 0



  const host = window.location.hostname;
  const isProd = process.env.NODE_ENV === 'production';
  /*const url = isProd
    ? 'api/getData/getData.php'
    : `http://${host}/react_projects/ISIGHT_v2/src/api/${mode === 'resumen' ? 'getResumen/getResumen.php' : 'getData/getData.php'}`;
*/
  /*const url = isProd
    ? 'api/getData/getData.php'
    : `api_react_test/${mode === 'resumen' ? 'getResumen/getResumen.php' : 'getData/getData.php'}`;
*/
     const url = isProd
    ? `api/${mode === 'resumen' ? 'getResumen/getResumen.php' : 'getData/getData.php'}`
    : `api_react_test/${mode === 'resumen' ? 'getResumen/getResumen.php' : 'getData/getData.php'}`;


   
    const suavizarData = (data, suavizado = 0.2) => {
    if (!data?.length) return [];
    const result = [];
    let lastValue = Number(data[0].visits);
    for (let i = 0; i < data.length; i++) {
      const current = Number(data[i].visits);
      const smoothed = suavizado * current + (1 - suavizado) * lastValue;
      result.push({ date: new Date(data[i].date).getTime(), value: smoothed });
      lastValue = smoothed;
    }
    return result;
  };


  const formatearTexto = (texto) => {
  return texto
    .replace(/_/g, ' ')         // reemplaza guiones bajos por espacio
    .replace(/\b\w/g, l => l.toUpperCase()); // pone mayúscula al inicio de cada palabra
};


  const updateLine = () => {
    
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        task, 
        Authorization: 'Client-ID ' + cookies.session_id, 
        tkd: id, 
        top, 
        last_id: lastId 
      })
    })
      .then(res => res.json())
      .then(i => {
        setData(i);
        lastId = i.last_id;
        lastUnix = i.last_unix;
        DS = i.DS;
        let delaySec = Math.floor(Date.now() / 1000) - lastUnix;
        let delay =
          delaySec >= 86400 ? Math.round(delaySec / 86400) + ' dias' :
          delaySec >= 3600 ? Math.round(delaySec / 3600) + ' hrs' :
          delaySec >= 60 ? Math.round(delaySec / 60) + ' min' :
          Math.round(delaySec) + ' seg';

        let transformed = [];
        if (i?.data && seriesRef.current) {
          transformed = mode === 'resumen'
            ? suavizarData(i.data)
            : i.data.map(item => ({ date: new Date(item.date).getTime(), value: item.visits }));
          seriesRef.current.data.setAll(transformed);
        }

        if (onLastValueChange && transformed.length > 0) {
          const lastValue = transformed[transformed.length - 1].value;
          //onLastValueChange(lastValue.toLocaleString("es-CL"), delay,DS);
          onLastValueChange(lastValue.toLocaleString("es-CL"), delay, task, DS,delaySec);
        }

        if (mode !== 'resumen' && scrollbarXRef.current && !zoomedOnceRef.current) {
          scrollbarXRef.current.set("start", 0.8);
          scrollbarXRef.current.set("end", 1);
          zoomedOnceRef.current = true;
        }
      })
      .catch(err => console.log('Error de datos:\n' + err));
  };




const resumeClass = mode === 'resumen'?'line-chart-container-sm':'line-chart-container' 

const bajadaA = "Esta información se actualiza cada 5 minutos."+
                "\nRepresenta la lectura del acumulador registrada"+
                "\ncada vez que el motor de la máquina estuvo detenido."


const bajadaB = "Esta información muestra datos en tiempo real, segundo a segundo"+ 
"\nLa muestra actual abarca 600 segundos (10 minutos)";

const bajadaTxt = mode === 'resumen'?bajadaA:bajadaB




  useEffect(() => {
    updateLine();
    const intervalId = setInterval(updateLine, tiempo);
    return () => clearInterval(intervalId);
  }, []);

  useLayoutEffect(() => {
    const root = am5.Root.new(chartRef.current);
    root.setThemes([am5themes_Animated.new(root)]);
    root._logo.dispose();

    const chart = root.container.children.push(am5xy.XYChart.new(root, {
      layout: root.verticalLayout,
      panX: true,
      panY: true,
    }));

    if (mode !== 'resumen') {
      const scrollbarX = am5.Scrollbar.new(root, { orientation: "horizontal" });
      scrollbarXRef.current = scrollbarX;
      scrollbarX.startGrip.setAll({ background: am5.RoundedRectangle.new(root, { fill: am5.color(0x555555), cornerRadiusTL: 8, cornerRadiusBL: 8, width: 10, height: 40 }) });
      scrollbarX.endGrip.setAll({ background: am5.RoundedRectangle.new(root, { fill: am5.color(0x555555), cornerRadiusTR: 8, cornerRadiusBR: 8, width: 10, height: 40 }) });
      scrollbarX.get("background").setAll({ fill: am5.color("#303030"), fillOpacity: 5 });
      scrollbarX.thumb.setAll({ fill: am5.color(0x555555), fillOpacity: 1, cornerRadius: 5, height: 10 });
      chart.set("scrollbarX", scrollbarX);
      chart.children.push(scrollbarX);
    }

    const xAxis = chart.xAxes.push(am5xy.DateAxis.new(root, {
      maxDeviation: mode === 'resumen' ? 0.1 : 0.2,
      groupData: false,
      baseInterval: { timeUnit: "second", count: mode === 'resumen' ? 10 : 1 },
      renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 75 })
    }));

    const yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
      renderer: am5xy.AxisRendererY.new(root, {}),
      min: 0,
      strictMinMax: true,
      extraMin: 0,
      extraMax: 0.1
    }));

    //const series = chart.series.push(am5xy.SmoothedXLineSeries.new(root, {
    const series = chart.series.push(am5xy.LineSeries.new(root, {
      name: "Valor",
      xAxis,
      yAxis,
      valueYField: "value",
      valueXField: "date",
      tooltip: am5.Tooltip.new(root, {
        labelText: "{valueY} PSI\n{valueX.formatDate('HH:mm:ss')}"
      })
    }));


    series.fills.template.setAll({
      visible: true,
      fillOpacity: 0.1
    });


    series.set("tensionX", 0);
    series.set("stroke", am5.color(0xFF9900));


    series.strokes.template.setAll({
      stroke: am5.color(0xFF9900),
      strokeWidth: 1
    });

    series.set("fill", am5.color(0x888888));       // importante: establece el color
    series.set("fillOpacity", 0.2);                // establece la opacidad
    series.set("fillVisible", true);               // ¡esto es lo que faltaba!


    seriesRef.current = series;

    const cursor = am5xy.XYCursor.new(root, {});
    cursor.lineY.set("visible", false);
    cursor.lineX.set("visible", true);
    cursor.set("xAxis", xAxis);
    cursor.set("yAxis", yAxis);
    chart.set("cursor", cursor);

    root.interfaceColors.set("text", am5.color(0x888888));

    [xAxis, yAxis].forEach(axis => {
      axis.get("renderer").grid.template.setAll({ stroke: am5.color(0x888888), strokeOpacity: 0.3 });
      axis.get("renderer").labels.template.setAll({ fontSize: 12 });
    });

    yAxis.get("renderer").set("minGridDistance", 10);
    xAxis.get("renderer").set("minGridDistance", 30);

    /*chart.children.unshift(am5.Label.new(root, {
      text: formatearTexto(task),
      fontSize: 18,
      fontWeight: "500",
      textAlign: "center",
      x: am5.percent(50),
      centerX: am5.percent(50),
      paddingBottom: 0,
      centerY: am5.percent(100),
      marginTop: 0 // más pegado
    }));
    */

 chart.children.unshift(am5.Label.new(root, {
      text: formatearTexto(task),
      fontSize: 18,
      fontWeight: "500",
      textAlign: "center",
      x: am5.percent(50),
      centerX: am5.percent(50),
      y: -5, // ⬅️ sube el título
      fill: am5.color(0xcccccc)
    }));

/*-----------  texto --------*/

chart.children.push(am5.Label.new(root, {
  text:bajadaTxt , 
  fontSize: 10,                                  // 🔠 Fuente pequeña
  fill: am5.color(0x888888),                     // 🎨 Color gris claro
  x: am5.percent(50),
  centerX: am5.percent(50),
  y: am5.percent(100),                           // 📍 Posición al final
  paddingTop: -18,
  textAlign: "center"
}));

 




   


    return () => root.dispose();
  }, []);

  return <div ref={chartRef} className={resumeClass} />;
};

export default LineChart;
